// ** Auth Endpoints
export default {
  refreshEndpoint: "/refresh-token",
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
  logoutEndpoint: "/logout",

  baseURL: import.meta.env.VITE_API_URL,
  GOOGLEMAPKEY:'AIzaSyCVuNTJdYimtj1Oij8TxPEqdQVtf9hO-qs',
  // npiUrl:"https://npiregistry.cms.hhs.gov/api/",
  // ** This will   be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
};
